import React from 'react';
import PropTypes from 'prop-types';
import isRequiredForA11y from 'prop-types-extra/lib/isRequiredForA11y';
import elementType from 'prop-types-extra/lib/elementType';
import Dropdown from '../Dropdown/Dropdown.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DropdownButton(_ref) {
  let {
    bsSize,
    bsStyle,
    title,
    noCaret,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs(Dropdown, {
    ...props,
    bsSize: bsSize,
    bsStyle: bsStyle,
    children: [/*#__PURE__*/_jsx(Dropdown.Toggle, {
      bsSize: bsSize,
      bsStyle: bsStyle,
      noCaret: noCaret,
      children: title
    }), /*#__PURE__*/_jsx(Dropdown.Menu, {
      children: children
    })]
  });
}
export default DropdownButton;